import { render, staticRenderFns } from "./AsideRightMenu.vue?vue&type=template&id=1f08eb64&scoped=true"
import script from "./AsideRightMenu.vue?vue&type=script&lang=js"
export * from "./AsideRightMenu.vue?vue&type=script&lang=js"
import style0 from "./AsideRightMenu.vue?vue&type=style&index=0&id=1f08eb64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f08eb64",
  null
  
)

export default component.exports